import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    ServiceCenterFormType,
} from '../serviceCenters.types'

const fields: DTOCardFormField<keyof ServiceCenterFormType>[] = [
    {
        id: 'serviceCenterMetrics',
        title: 'SERVICE_CENTER_METRICS',
        className: 'serviceCenterMetrics',
        fields: [{
            id: 'serviceCenterMetrics-column1',
            fields: [
                {
                    name: 'orderSelectionDelay',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'ORDER_SELECTION_DELAY',
                },
                {
                    name: 'maxTrucksPerDay',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'MAX_TRUCKS_PER_DAY',
                },
                {
                    name: 'processingThroughput',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'PROCESSING_THROUGHPUT',
                },
            ],
        }],
    },
    {
        id: 'productMetrics',
        title: 'PRODUCT_METRICS',
        className: 'productMetrics',
        fields: [{
            name: 'productMetrics',
            componentName: 'ProductMetrics',
            exists: true,
            required: true,
            disabledFields: {
                productType: true,
                safeMinimumUsableStock: true,
            },
        }],
    },
    {
        id: 'storages',
        title: 'STORAGES',
        className: 'storages',
        fields: [{
            name: 'storages',
            componentName: 'Storages',
            showFields: {
                dailyPreconditioningCapacity: true,
            },
            exists: true,
            required: true,
            disabled: true,
        }],
    },
]

export default fields
